var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    transform: "matrix(-1 0 0 1 30 0)",
    fill: "white",
    stroke: "url(#paint0_linear_2609_18922)",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2998,
    cy: 15.5,
    r: 10,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5499 15.8006C16.5499 16.3253 16.1246 16.7506 15.5999 16.7506C15.0752 16.7506 14.6499 16.3253 14.6499 15.8006C14.6499 15.2759 15.0752 14.8506 15.5999 14.8506C16.1246 14.8506 16.5499 15.2759 16.5499 15.8006Z",
    fill: "#00A651",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6001 20.6006V23.0006",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6001 15.7998L7.2001 15.7998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6001 7.40039V9.80039",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6001 12.2002V14.6002",
    stroke: "black",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7998 15.7998L20.3998 15.7998",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2609_18922",
    x1: 1.05132e-9,
    y1: 15.0242,
    x2: 30,
    y2: 14.9758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ABC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.6e9da4621367cd40d865f8f7104c0f47.svg";
export { ForwardRef as ReactComponent };